// PORT of `Report Generation Service/utils/scanSchemaVersion.js` — keep the two in sync.
//
// Report templates are written against one shape of scan JSON, and scanner 2.0 changes
// that shape. The compatibility key is the scanner's MAJOR version ("1.4.1" → 1,
// "2.0.0" → 2); a template stores the major it was built for in `scan_schema_version`
// and is only offered for scans of the same major. Scans with no readable version are
// pre-2.0, so they count as 1.

export const LEGACY_SCAN_SCHEMA_VERSION = 1;

const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);

const majorOf = (version) => {
  if (version === null || version === undefined) return null;
  const match = String(version).trim().match(/^v?(\d+)/i);
  if (!match) return null;
  const major = parseInt(match[1], 10);
  return Number.isFinite(major) && major > 0 ? major : null;
};

const headerVersion = (obj) => {
  if (!isPlainObject(obj)) return null;
  // The scanner has always spelled it "Pisqueak"; accept the correct spelling too.
  const header = obj.Pisqueak || obj.Pipsqueak;
  return isPlainObject(header) ? header.version : null;
};

export const readScanVersion = (scan) => {
  if (!isPlainObject(scan)) return null;

  const top = headerVersion(scan);
  if (top) return top;

  if (Array.isArray(scan.localhosts)) {
    for (const entry of scan.localhosts) {
      const v = headerVersion(entry?.scan_results) || headerVersion(entry) || entry?.scanner_version;
      if (v) return v;
    }
  }

  return scan._metadata?.scanner_version || scan.scanner_version || null;
};

export const detectScanSchemaVersion = (scan) =>
  majorOf(readScanVersion(scan)) || LEGACY_SCAN_SCHEMA_VERSION;

export const toSchemaVersion = (value) => majorOf(value) || LEGACY_SCAN_SCHEMA_VERSION;

/** Short label for UI, e.g. 1 → "v1.x". */
export const schemaVersionLabel = (value) => `v${toSchemaVersion(value)}.x`;
